import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { SectionsBrandsComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { StrapiMedia } from '../../atoms'

import * as styles from './brands.styles'

export const Brands = ({
  title,
  highlighted,
  src,
}: SectionsBrandsComponent) => {
  const { before, after, highlight } = useHighlightedText(title, highlighted)

  return (
    <section css={styles.section}>
      <div css={styles.content}>
        <Typography css={styles.title} fontWeight="heavy" variant="h2">
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </Typography>
        {src && src.length > 0 && (
          <div css={styles.brands}>
            {src.map((item) => (
              <StrapiMedia key={item.id} {...item.src} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
